import { render } from "./ResendEvents.vue?vue&type=template&id=0754bc2b"
import script from "./ResendEvents.vue?vue&type=script&lang=js"
export * from "./ResendEvents.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__